import {
  drawispringsummarytree
} from './summary'
  
export const initPlaybackControls = (
  $,
  dataispringsummary,
  player,
  playbackController, 
  slidesCount,
  $ispringsummarytree,
  $issprintnavprogressbar,
  $issprintnavreload,
  $issprintnavfullscreen,
  $issprintnavprev,
  $issprintnavnext
) => {

  window.API.setISpringData({
    ispringslidestotal: slidesCount
  })

  $issprintnavreload.on(
    'click',
    function() {

      playbackController.gotoPreviousStep()
      playbackController.play()
    }
  )

  $issprintnavprev.on(
    'click',
    function() {

      const disabled = $(this).hasClass('Disabled')
      
      if(!disabled) {
        
        playbackController.gotoPreviousSlide()
      }
    }
  )

  $issprintnavnext.on(
    'click',
    function() {

      const disabled = $(this).hasClass('Disabled')
      
      if(!disabled) {

        playbackController.gotoNextSlide()
      }
    }
  )

  playbackController.slideChangeEvent().addHandler(function(slideIndex) {

    if(
      !window.API.ispringdata.started
      &&
      window.API.ispringdata.ispringslidesactualvisited != slideIndex
    ) {

      window.API.setISpringData({
        started: true
      })

      playbackController.gotoSlide(window.API.ispringdata.ispringslidesactualvisited)

      // return
    }

    if(slideIndex == 0) {

      $issprintnavprev.addClass('Disabled')

    } else {

      $issprintnavprev.removeClass('Disabled')
    }

    if(slideIndex == slidesCount - 1) {

      $issprintnavnext.addClass('Disabled')

    } else {

      $issprintnavnext.removeClass('Disabled')
    }  

    window.API.setISpringData({
      ispringslideslastvisited: Math.max(
        slideIndex,
        window.API.ispringdata.ispringslideslastvisited
      ),
      ispringslidesactualvisited: slideIndex
    })

    const lastslide = window.API.ispringdata.ispringslideslastvisited

    $issprintnavprogressbar.css('width', ((lastslide+ 1) * 100 / slidesCount) + '%')

    drawispringsummarytree(
      $,
      $ispringsummarytree,
      playbackController,
      dataispringsummary, 
      slideIndex
    )
  })
} 